<template>
  <hic-list-page title="检治集" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" keyword-placeholder="名称或编码">
    <template slot="buttons">
      <el-button v-if="!isSwitch" type="primary" @click="create" size="small">
        <i class="el-icon-plus"></i>
        新建
      </el-button>

      <el-button type="warning" @click="tools" size="small" v-if="!isSwitch">
        <i class="el-icon-s-tools"></i>
        生成项目
      </el-button>

      <el-button @click="isSwitch = false" size="small" v-if="isSwitch">
        <i class="el-icon-error"></i>
        取消
      </el-button>

      <el-button type="primary" @click="produce" size="small" v-if="isSwitch" :disabled="!entities.items.some((m) => m.isProduce)">
        <i class="el-icon-success"></i>
        生成
      </el-button>
    </template>

    <el-table-column label="操作" width="150" align="center">
      <template #default="scope">
        <el-checkbox
          size="medium"
          v-if="isSwitch"
          v-model="scope.row.isProduce"
          @change="
            () => {
              scope.row.isProduce = !scope.row.isProduce;
            }
          "
        ></el-checkbox>
        <el-button v-if="!isSwitch" type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(scope.row, scope.$index)" />
        <hic-regret-button v-if="!isSwitch" type="danger" icon="el-icon-delete" circle plain @click="del(scope.row, scope.$index)" :seconds="5" size="mini" badge="success" :disabled="!scope.row.id" class="left-pad"></hic-regret-button>
        <el-tag v-if="!scope.row.id" size="mini" type="info">已删除</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="名称" prop="name" min-width="200">
      <template slot-scope="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column label="编码" prop="code" width="100" align="left">
      <template slot-scope="{ row }">
        {{ row.code }}
      </template>
    </el-table-column>
    <el-table-column label="助记符" prop="shortCode" width="150" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        {{ row.shortCode }}
      </template>
    </el-table-column>

    <el-table-column label="备注" prop="memo" min-width="250" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        {{ row.memo }}
      </template>
    </el-table-column>

    <staff-edit :visible.sync="showEditor" v-model="entity" @ok="ok" />
  </hic-list-page>
</template>

<script>
  import api from "./api.js";
  import store from "@/common/store";
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      "staff-edit": () => import("./edit"),
    },
    data() {
      return {
        isSwitch: false,
        showEditor: false,
        showRoles: false,
        entities: {},
        entity: {},
        condition: {
          keyword: null,
          deptCode: null,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        meta: {
          loading: false,
        },

        editingIndex: -1,
      };
    },
    computed: {
      ...mapGetters(["dict", "permission"]),
    },
    created: function () {
      this.$store.dispatch("loadDicts", ["Dept", "Gender", "StaffType", "DoctorPosition"]);
    },
    methods: {
      rowClick(row) {
        if (this.isSwitch) {
          this.$set(row, "isProduce", !row.isProduce);
        }
      },
      tableRowClassName({ row, rowIndex }) {
        if (this.isSwitch) {
          if (row.isProduce) {
            return "active-row";
          }
          return "shover-row";
        }
      },
      produce() {
        let items = this.entities.items.filter((f) => f.isProduce);
        items.forEach(async (item, index) => {
          try {
            await api.item.save({ name: item.name, srcCode: item.code, srcType: "检治集" });
            if (index == items.length - 1) {
              this.$message.success("生成成功!");
              this.isSwitch = false;
            }
          } catch (error) {
            this.$message.error(error);
          }
        });
      },
      tools() {
        this.isSwitch = true;
      },
      page() {
        let _this = this;
        this.loading = true;
        api.ExamineSet.query(this.condition)
          .then((res) => {
            _this.entities = res;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            _this.loading = false;
          });
      },
      create() {
        this.editingIndex = 0;
        this.entity = {};
        this.showEditor = true;
      },
      edit(row, index) {
        this.entity = JSON.parse(JSON.stringify(row));
        this.showEditor = true;
      },
      ok(newEntity) {
        this.page();
      },
      del(row, index) {
        let _this = this;
        api.ExamineSet.del(row.id).then((res) => {
          _this.entities.items.splice(index, 1, {});
          _this.$message.success("删除成功！");
        });
      },
      bingRole(row) {
        this.entity = row;
        this.showRoles = true;
      },
      filterChanged(options) {
        options[Object.keys(options)[0]] = Object.values(options)[0][0];
        Object.assign(this.condition, options);
        this.page();
      },
    },
  };
</script>